// @ts-nocheck
import { isUndefined } from "lodash";
import { Document, Page } from "react-pdf";
import { Rnd } from "react-rnd";
import styles from "../contractDetails.module.css";
import { CustomIconButton } from "../../../components/Custom/CustomIconButton";
import { ArrowBack, ArrowForward, Cancel, Download } from "@mui/icons-material";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import PropTypes from "prop-types";
import { useState } from "react";
import { FileUpload } from "./FileUpload";
import { pdfjs } from "react-pdf";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { Box } from "@mui/system";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

const customBtnStyles = {
  backgroundColor: getCssVariableHandler({
    variableName: "--light-grey-1-rgb",
  }),
  padding: "0.25rem",
  "&:hover": {
    backgroundColor: getCssVariableHandler({
      variableName: "--light-grey-1-rgb",
    }),
  },
};

export const RightContract = ({
  file,
  setTotalPage,
  currPage,
  setCurrPage,
  setFields,
  fields,
  totalPage,
  fileChangeHandler,
  handleDownloadContract,
  readOnly,
  drop,
}) => {
  const [editingFieldId, setEditingFieldId] = useState(null);
  const [showFields, setShowFields] = useState(false);

  function onPdfLoadSuccess({ numPages }) {
    setTotalPage(numPages);
    setShowFields(true);
  }

  return (
    <>
      <div id="drop-area" ref={drop}>
        {file ? (
          <>
            <Document
              file={file}
              onLoadError={(e) => undefined}
              onLoadSuccess={onPdfLoadSuccess}
              options={options}
              loading={
                <Box
                  sx={{
                    position: "relative",
                    height: "100px",
                    width: "300px",
                  }}
                >
                  <LoadingOverlay open={true} />
                </Box>
              }
            >
              <Page
                pageNumber={currPage}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                scale={1}
              />
            </Document>

            {showFields &&
              fields
                ?.filter((f) => f.page == currPage)
                ?.map((field) => (
                  <Rnd
                    key={field.id}
                    cancel={".field-options"}
                    disableDragging={readOnly}
                    enableResizing={!readOnly}
                    default={{
                      x: field.x,
                      y: field.y,
                      width: field.width ?? 120,
                      height: field.height ?? 40,
                    }}
                    onResizeStop={(_, __, ref, ___, position) => {
                      setFields((prev) =>
                        prev.map((f) =>
                          f.id === field.id
                            ? {
                                ...f,
                                x: position.x,
                                y: position.y,
                                width: parseFloat(ref.style.width),
                                height: parseFloat(ref.style.height),
                              }
                            : f,
                        ),
                      );
                    }}
                    onDragStop={(_, d) => {
                      setFields((prev) =>
                        prev.map((f) =>
                          f.id === field.id ? { ...f, x: d.x, y: d.y } : f,
                        ),
                      );
                    }}
                    bounds="#drop-area"
                    className={styles["field-box"]}
                  >
                    {editingFieldId === field.id && field.type === "Text" ? (
                      <textarea
                        autoFocus
                        onFocus={(e) => e?.target?.select()}
                        style={{
                          width: "100%",
                          height: "100%",
                          resize: "none",
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          color: "teal",
                          font: "inherit",
                        }}
                        value={field.value ?? ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFields((prev) =>
                            prev.map((f) =>
                              f.id === field.id ? { ...f, value } : f,
                            ),
                          );
                        }}
                        onBlur={() => setEditingFieldId(null)}
                      />
                    ) : field.type === "Text" ? (
                      <div
                        style={{
                          color: "teal",
                          width: "100%",
                          height: "100%",
                          fontSize: "14px",
                        }}
                        onDoubleClick={() => {
                          if (readOnly) return;
                          if (field.type === "Text")
                            setEditingFieldId(field.id);
                        }}
                      >
                        {field.value || field.type}
                      </div>
                    ) : (
                      <img
                        src={field.value}
                        style={{
                          height: "100%",
                          width: "100%",
                          pointerEvents: "none",
                        }}
                        alt={"Signature"}
                      />
                    )}
                    {!readOnly && (
                      <div
                        style={{ pointerEvents: "auto" }}
                        className={styles["field-options"]}
                      >
                        <CustomIconButton
                          sx={{
                            ...customBtnStyles,
                            padding: 0,
                            "& svg": {
                              fill: getCssVariableHandler({
                                variableName: "--primary-pink-hex",
                              }),
                            },
                          }}
                          onClick={() =>
                            setFields((prev) =>
                              prev?.filter((item) => item?.id !== field.id),
                            )
                          }
                          onTouchStart={() =>
                            setFields((prev) =>
                              prev?.filter((item) => item?.id !== field.id),
                            )
                          }
                        >
                          <Cancel fontSize="small" />
                        </CustomIconButton>
                      </div>
                    )}
                  </Rnd>
                ))}
          </>
        ) : (
          <FileUpload
            text={"Upload contract here"}
            fileChangeHandler={fileChangeHandler}
            noBackground
          />
        )}
      </div>
      <div className={styles["bottom-btn"]}>
        <CustomIconButton
          sx={{
            ...customBtnStyles,
          }}
          onClick={() =>
            setCurrPage((prev) =>
              isUndefined(prev) || prev === 1 ? prev : prev - 1,
            )
          }
        >
          <ArrowBack sx={{ fontSize: "1.5rem" }} />
        </CustomIconButton>
        <p>
          Page {currPage} of {totalPage}
        </p>
        <CustomIconButton
          sx={{ ...customBtnStyles }}
          onClick={() =>
            setCurrPage((prev) =>
              isUndefined(prev) || prev === totalPage ? prev : prev + 1,
            )
          }
        >
          <ArrowForward sx={{ fontSize: "1.5rem" }} />
        </CustomIconButton>
        <CustomIconButton onClick={handleDownloadContract}>
          <Download sx={{ fontSize: "1.5rem" }} />
        </CustomIconButton>
      </div>
    </>
  );
};
RightContract.propTypes = {
  file: PropTypes.any.isRequired,
  setTotalPage: PropTypes.func.isRequired,
  currPage: PropTypes.number.isRequired,
  setCurrPage: PropTypes.func.isRequired,
  setFields: PropTypes.func.isRequired,
  fields: PropTypes.array.isRequired,
  totalPage: PropTypes.number.isRequired,
  fileChangeHandler: PropTypes.func.isRequired,
  handleDownloadContract: PropTypes.func,
  readOnly: PropTypes.bool,
};